// ///////////////////////////////
// Google Tag Manager Functions //
// ///////////////////////////////

import ServiceBase from "@affinity/Store/ServiceBase"
import { getCookie } from "@insite/client-framework/Common/Cookies";

class ServiceTracking extends ServiceBase {
    // TODO: New event names needed for Affinity
    readonly CustomEventNames = {
        productSelection: "fuel_order_product_selected",
        quantitySelection: "fuel_order_quantity_selected",
        confirmQtyModal: "fuel_order_capacity_confirmation",
        deliveryAddressSelection: "fuel_order_delivery_address_selection",
        priceSelection: "fuel_order_price_selected",
        deliveryInstruction: "fuel_order_delivery_instructions",
        addBasket: "fuel_order_addbasket_order",
        basketCartContinue: "fuel_order_continue_shopping",
        /* basketCartCheckout: "fuel_order_checkout", */
        orderPlaced: "fuel_order_placed",
    }
    private lastTrackedUrl = "";
    private readonly dataLayer;
    private readonly ga;

    constructor() {
        super();
        this.dataLayer = (window as any).dataLayer;
        this.ga = (window as any).ga;
    }

    // TODO: Review methods and properties to make private

    trackPageChange(virtualTitle: string, virtualUrl: string) {
        if (IS_SERVER_SIDE) {
            return;
        }
    
        const url = window.location.pathname + virtualUrl;
        if (url === this.lastTrackedUrl) {
            return;
        }
    
        const title = `${document.title} | ${virtualTitle}`;
    
        this.lastTrackedUrl = url;
    
        if (this.dataLayer) {
            this.dataLayer.push({
                event: "virtualPageView",
                page: {
                    title,
                    url,
                },
            });
        } else if (this.ga) {
            this.ga("set", "location", url);
            this.ga("set", "page", title);
            this.ga("send", "pageview");
        }
    }

    getDateTime() {
        return { "dateTime": (new Date).toISOString() };
    }

    getBillToId() {
        const cookieValue = getCookie("CurrentBillToId");
        return { "memberAccount": cookieValue! ?? "" };
    }

    trackEvent(eventName: string, eventVariables: any) {
        if (IS_SERVER_SIDE) {
            return;
        }
    
        if (this.dataLayer) {
            this.dataLayer.push({
                ...this.getDateTime(),
                ...this.getBillToId(),
                ...eventVariables,
                'event': eventName,
            })
        }
    }

    // TODO: ADD CUSTOM EVENT TRACKING METHODS

    confirmQtyModal() {
        const eventName = this.CustomEventNames.confirmQtyModal;
        // datetime
    
        this.trackEvent(eventName, {}); // TODO: Review this
    }
}

export default ServiceTracking;